import React from 'react';
import PropTypes from 'prop-types';

function scrollToSelector(selector) {
  if (
    !selector ||
    typeof window === 'undefined' ||
    typeof document === 'undefined'
  )
    return;
  const el = document.querySelector(selector);
  if (!el) return;
  const top = el.offsetTop || 0;
  try {
    window.scrollTo({ top, behavior: 'smooth' });
  } catch (_) {
    window.scrollTo(0, top);
  }
}

function navigateTo(link, target) {
  if (!link || !link.href) return;
  if (target === '_blank') {
    window.open(link.href, '_blank');
    return;
  }
  window.location.href = link.href;
}

function openPopup(selector) {
  if (
    !selector ||
    typeof window === 'undefined' ||
    typeof document === 'undefined'
  )
    return;
  const el = document.querySelector('.modal-overlay' + selector);
  if (!el) return;
  try {
    el.style.display = 'flex';
    document.body.classList.add('modal-open');
  } catch (_) {}
}

export default function CTA({ children, cta, variant, isLink }) {
  if (!cta || Object.keys(cta).length === 0) return children;
  const { type, title, supplementary_text: supplementaryText, action, customBtnCss, disabled, customHandleClick } = cta;
  const handleClick = (e) => {
    if (type === 'open_popup' && action && action?.selector) {
      e?.preventDefault?.();
      openPopup(action?.selector);
      return;
    }
    if (type === 'scroll_to' && action && action?.selector) {
      e?.preventDefault?.();
      scrollToSelector(action?.selector);
      return;
    }
    if (type === 'redirect' && action) {
      // If we're rendering an <a>, let native navigation occur unless target === '_route'
      if (action?.target === '_route') {
        e?.preventDefault?.();
        navigateTo(action?.link, action?.target);
      }
    }
  };

  const isPrimary = variant === 'primary';
  let buttonClass = isPrimary
    ? 'btn btn-gr'
    : 'btn btn-gr-outline route-link';
  
  if(customBtnCss) {
    buttonClass = customBtnCss;
  }

  return (
    <>
      {supplementaryText ? (
        <p className='title-secondary'>{supplementaryText}</p>
      ) : null}
      {isLink ? (
        <a
          href={action?.link?.href}
          target={action?.target === '_blank' ? '_blank' : undefined}
          rel={action?.target === '_blank' ? 'noopener noreferrer' : undefined}
          onClick={handleClick}
        >
          {children}
        </a>
      ) : (
        <button 
          className={buttonClass} 
          disabled={disabled || false}
          onClick={customHandleClick ? customHandleClick : handleClick}>
          {title}
        </button>
      )}
    </>
  );
}

CTA.propTypes = {
  cta: PropTypes.shape({
    type: PropTypes.string,
    title: PropTypes.string,
    supplementary_text: PropTypes.string,
    action: PropTypes.shape({
      selector: PropTypes.string,
      link: PropTypes.shape({ href: PropTypes.string }),
      target: PropTypes.string,
    }),
  }),
  variant: PropTypes.oneOf(['primary', 'secondary']),
};

CTA.defaultProps = {
  variant: 'primary',
};
